import {
  Avatar,
  AvatarGroup,
  Box,
  Flex,
  IconButton,
  Link,
  Popover,
  PopoverArrow,
  PopoverBody,
  PopoverCloseButton,
  PopoverContent,
  PopoverTrigger,
  Skeleton,
  Text,
} from '@chakra-ui/react';
import _ from 'lodash';
import ButtonMinor from '../../../../components/ButtonMinor';
import {MdInfoOutline, MdOutlinePanoramaPhotosphere} from 'react-icons/md';
import {CloseIcon, ExternalLinkIcon} from '@chakra-ui/icons';
import React from 'react';
import {sendAudioClick, sendExternalUrl, sendPanoIdSearch} from '../../../../vuplex';
import {useSelector} from 'react-redux';
import InAppTooltip from '../../UnityReactComponents/InAppTooltip';

const PanoToastFoundNew360 = ({
  onSaveButtonClick,
  onCloseClick,
}) => {
  const panoId = useSelector(s => s.inApp.panoId);
  const panoLocation = useSelector(s => s.inApp.panoLocation);
  const pinsMax = 5;

  const panoContributor = useSelector(s => s.inApp.panoContributor);
  const panoContributorIcon = useSelector(s => s.inApp.panoContributorIcon);
  const panoContributorLink = useSelector(s => s.inApp.panoContributorLink);

  const {
    error,
    isLoading,
    response: pinsSearchResponse,
  } = useSelector(s => s.pins.pinsPanoIdSearch);

  const {hasNextPage, page, pins = []} = pinsSearchResponse || {};

  const isOwnedByUser = pins.find(p => p.isOwnedByUser);

  const handleClickExistingPins = (e) => {
    // sendAudioClick(e);
    sendPanoIdSearch({
      lat: panoLocation.latitude,
      lon: panoLocation.longitude,
      panoId,
    });
  };

  const noShadow = {
    _focus: {
      shadow: 'none',
    },
    _focusVisible: {
      shadow: 'none',
    },
  };

  return (
    <Flex
      alignItems="center"
      justify="space-between"
      bg="#007AFF"
      borderRadius="2xl"
      color="white"
      gap={2}
      p={2}
      // w="55vw"
    >
      {panoContributor && (
        <Popover>
          <PopoverTrigger>
            <IconButton
              colorScheme="white"
              icon={<MdInfoOutline size="2em"/>}
              isRound
            />
          </PopoverTrigger>

          <PopoverContent borderRadius="2xl" {...noShadow} w="auto">
            <PopoverArrow />
            <PopoverCloseButton/>
            <PopoverBody>

              <InAppTooltip message="Click to open uploader's profile in your system browser">
                <Link
                  onClick={(e) => {
                    sendAudioClick(e);
                    sendExternalUrl({url: `https:${panoContributorLink}`
                  });
                  }}
                >
                  <Flex alignItems="center" color="black24" gap={1}>
                    <Avatar src={panoContributorIcon} size="sm"/>
                    <Text noOfLines={1}>{panoContributor}</Text>
                    <ExternalLinkIcon/>
                  </Flex>

                </Link>
              </InAppTooltip>

            </PopoverBody>
          </PopoverContent>
        </Popover>
      )}

      <Skeleton isLoaded={!isLoading} flexShrink={0}>
        <Box>
          {!pins.length
            ? <Text px={2}>You found a new 360!</Text>
            : (
              <Flex
                alignItems="center"
                bg="whiteAlpha.400"
                borderRadius="full"
                p={0}
                paddingLeft={2}
              >
                <Text>Saved by:</Text>
                <AvatarGroup
                  onClick={handleClickExistingPins}
                  marginX={2}
                >
                  {_.take(pins, pinsMax).map(({
                    _id,
                    ownerAlias,
                    ownerIsOnline,
                    ownerProfilePhotoURL,
                  }, i) => (
                    <Avatar
                      borderColor={ownerIsOnline ? 'lightgreen' : 'null'}
                      key={i}
                      name={ownerAlias}
                      shadow={`2px 1px 4px #000000aa`}
                      showBorder
                      size="xs"
                      src={ownerProfilePhotoURL}
                    />
                  ))}
                </AvatarGroup>

                {pins.length > pinsMax && (<Text marginRight={1}>+{pins.length - pinsMax}</Text>)}

                <ButtonMinor onClick={handleClickExistingPins}>
                  See All
                </ButtonMinor>
              </Flex>

            )}

        </Box>
      </Skeleton>

      <ButtonMinor
        disabledReason={isOwnedByUser ? 'You have already saved this 360.' : null}
        onClick={() => {
          onSaveButtonClick();
        }}
      >
        <MdOutlinePanoramaPhotosphere/>
        &nbsp;
        Save 360
      </ButtonMinor>

      <ButtonMinor
        bg="none"
        borderLeft="solid 1px"
        borderColor="whiteAlpha.500"
        borderRadius={0}
        onClick={() => onCloseClick()}
      >
        <CloseIcon color="white"/>
      </ButtonMinor>
    </Flex>
  );
};

export default PanoToastFoundNew360;